import React from 'react';
import styled from 'styled-components';
//
import colors from 'theme/colors';
import { TForecastToggleProps } from 'components/forecast-toggle';
import { EForecastEvaluationType } from 'store/deal-evaluation/types';

const { activeBackground, darkInputBorder, globalInputSelectedBg, primary, white, fontBody } = colors;

const ForecastToggleStyled = styled.div``;

const Title = styled.div`
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 8px;
`;

const fontWeightHigh = 600;
const fontWeightLow = 500;

const ForecastButton = styled.button<{ active: boolean }>`
  min-height: 24px;
  padding: 0px 8px;
  min-width: 50px;
  border: 0.5px solid ${darkInputBorder};
  color: ${props => (props.active ? primary : fontBody)};
  background-color: ${props => (props.active ? activeBackground : white)};
  font-weight: ${props => (props.active ? fontWeightHigh : fontWeightLow)};

  :active,
  :focus {
    outline: none;
  }

  :hover {
    cursor: pointer;
    background-color: ${globalInputSelectedBg} !important;
  }
`;

const ForecastButtonContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${ForecastButton}:first-of-type {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  ${ForecastButton}:last-of-type {
    border-left: none;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }
`;

export default ({ selectedForecastType, setForecastType, showTitle = true }: TForecastToggleProps) => (
  <ForecastToggleStyled>
    {showTitle ? <Title>FORECAST</Title> : null}
    <ForecastButtonContainer>
      <ForecastButton
        onClick={() => setForecastType(EForecastEvaluationType.IHS)}
        active={selectedForecastType === EForecastEvaluationType.IHS}
      >
        IHS Forecast
      </ForecastButton>
      <ForecastButton
        onClick={() => setForecastType(EForecastEvaluationType.SHELL)}
        active={selectedForecastType === EForecastEvaluationType.SHELL}
      >
        Shell Forecast
      </ForecastButton>
    </ForecastButtonContainer>
  </ForecastToggleStyled>
);
